import './themeswitch.scss'

/* React */
import { useEffect } from 'react'

/* Context */
import { useContext } from 'react'
import { AppContext } from 'src/AppContext'

const ThemeSwitch:React.FC = () => {

  const { appState:{theme}, appDispatch } = useContext(AppContext)
  const darkMode = theme === 'dark'

  const switchTheme = () => {
    localStorage.setItem('theme', darkMode ? 'light' : 'dark')
    appDispatch({ 
      type: 'THEME', 
      payload: darkMode ? 'light' : 'dark' 
    })
  } 

  useEffect(() => {
    darkMode
      ? document.documentElement.setAttribute('darkMode', '')
      : document.documentElement.removeAttribute('darkMode')
  }, [darkMode])

  return <div className="theme-switch">
    <div className="switch-track">
      <div className="switch-check">
        <span className="switch-icon">🌙</span>
      </div>
      <div className="switch-x">
        <span className="switch-icon">🌞</span>
      </div>
      <div className="switch-thumb"></div>
    </div>

    <input
      type="checkbox"
      checked={darkMode}
      onChange={switchTheme}
      aria-label="Switch between dark and light mode"
    />
  </div>
}

export default ThemeSwitch